function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient",
  x1: 1008.49,
  y1: -463.5,
  x2: 1103.44,
  y2: -313.16,
  gradientTransform: "matrix(1.39 -.05 -.05 1.45 -953.67 1120.22)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-2",
  x1: 807.5,
  y1: -612.28,
  x2: 898.81,
  y2: -467.7,
  xlinkHref: "#run_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-3",
  x1: 106.88,
  y1: 1105.45,
  x2: 157.64,
  y2: 1390.18,
  gradientTransform: "translate(0 -1042.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-4",
  x1: -88.93,
  y1: 1237.97,
  x2: 130.38,
  y2: 1218.93,
  xlinkHref: "#run_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-5",
  x1: 1.25,
  y1: 1257.54,
  x2: 259.86,
  y2: 1257.54,
  gradientTransform: "translate(0 -1042.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-6",
  x1: 29.32,
  y1: 1288.72,
  x2: 93.56,
  y2: 1288.16,
  gradientTransform: "translate(0 -1042.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#8e9dcf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-7",
  x1: 116.04,
  y1: 1103.82,
  x2: 166.8,
  y2: 1388.55,
  xlinkHref: "#run_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-8",
  x1: 69.44,
  y1: 1085.7,
  x2: 300.85,
  y2: 1389.46,
  gradientTransform: "translate(0 -1042.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-9",
  x1: 1.12,
  y1: 1204.54,
  x2: 260,
  y2: 1204.54,
  xlinkHref: "#run_svg__linear-gradient-5"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-10",
  x1: 29.32,
  y1: 1235.66,
  x2: 93.56,
  y2: 1235.1,
  xlinkHref: "#run_svg__linear-gradient-6"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-11",
  x1: -2211.28,
  y1: 176.95,
  x2: -2195.42,
  y2: 176.95,
  gradientTransform: "rotate(-5.37 244.013 -29646.728)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#535a8b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#7980b3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#878ec2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-12",
  x1: 164.65,
  y1: 427.31,
  x2: 167.31,
  y2: 432.04,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#6a7db9",
  stopOpacity: 0.27
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#92a0cc",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.85,
  stopColor: "#d4daeb",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-13",
  x1: 150.34,
  y1: 417.14,
  x2: 152.78,
  y2: 422,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#5c71b3",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.89,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-14",
  x1: 1269.06,
  y1: 373.57,
  x2: 1293.03,
  y2: 411.61,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  xlinkHref: "#run_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-15",
  x1: 771.44,
  y1: 435.85,
  x2: 1362.14,
  y2: 435.85,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#d8def0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "#ebeff7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.47,
  stopColor: "#dce2f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.49,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-16",
  x1: 1169.93,
  y1: 447.6,
  x2: 914.32,
  y2: 171.66,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.48,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.53,
  stopColor: "#eaeef7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#dbe0f1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#d2d8ed"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-17",
  x1: 847.78,
  y1: 430.08,
  x2: 1349.63,
  y2: 430.08,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.24,
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.43,
  stopColor: "#fff",
  stopOpacity: 0.86
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.51,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.55,
  stopColor: "#fff",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#fff",
  stopOpacity: 0.89
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.69,
  stopColor: "#fff",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#fff",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.97,
  stopColor: "#fff",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-18",
  x1: 1075.24,
  y1: 255.36,
  x2: 1229.07,
  y2: 545.62,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  xlinkHref: "#run_svg__linear-gradient-8"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-19",
  x1: 1073.94,
  y1: 419.93,
  x2: 1230.66,
  y2: 419.93,
  xlinkHref: "#run_svg__linear-gradient-17"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-20",
  x1: 1130.94,
  y1: -36.37,
  x2: 766.47,
  y2: 368.28,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.1,
  stopColor: "#d8def0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.38,
  stopColor: "#ebeff7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.56,
  stopColor: "#f2f5fa"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.61,
  stopColor: "#f0f3f9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#e9edf7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#dee3f2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.65,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#cfd6ec"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.86,
  stopColor: "#cfd6ec"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-21",
  x1: 889.84,
  y1: 77.17,
  x2: 1581.68,
  y2: 882.81,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  xlinkHref: "#run_svg__linear-gradient-3"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-22",
  x1: 842.65,
  y1: 200.46,
  x2: 1146.78,
  y2: 200.46,
  gradientTransform: "matrix(-1 0 0 1 1426.85 0)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.04,
  stopColor: "#fff",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#fff",
  stopOpacity: 0.86
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.08,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.16,
  stopColor: "#fff",
  stopOpacity: 0.97
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.28,
  stopColor: "#fff",
  stopOpacity: 0.89
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#fff",
  stopOpacity: 0.76
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.58,
  stopColor: "#fff",
  stopOpacity: 0.58
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#fff",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#fff",
  stopOpacity: 0.08
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-23",
  x1: 323.5,
  y1: -3297.65,
  x2: 647.06,
  y2: -3297.65,
  gradientTransform: "matrix(1 1.15 0 1 .26 2957.86)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#afbee4",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#afbee4",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-24",
  x1: 323.48,
  y1: -3223.38,
  x2: 647.04,
  y2: -3223.38,
  xlinkHref: "#run_svg__linear-gradient-23"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-25",
  x1: -1830.3,
  y1: 251.84,
  x2: -1794.76,
  y2: 286.49,
  gradientTransform: "translate(2425.35)",
  xlinkHref: "#run_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-26",
  x1: -1829.31,
  y1: 243.98,
  x2: -1832.27,
  y2: 277.55,
  gradientTransform: "translate(2425.35)",
  xlinkHref: "#run_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-27",
  x1: -1758.03,
  y1: 606.28,
  x2: -1751.12,
  y2: 576.07,
  gradientTransform: "rotate(7.58 2105.06 18187.54)",
  xlinkHref: "#run_svg__linear-gradient-11"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-28",
  x1: -1739.75,
  y1: 589.76,
  x2: -1722.27,
  y2: 589.76,
  gradientTransform: "rotate(7.58 2105.06 18187.54)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-29",
  x1: -1758.13,
  y1: 577.76,
  x2: -1744.48,
  y2: 580.3,
  gradientTransform: "rotate(7.58 2105.06 18187.54)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#313866",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.63,
  stopColor: "#313866",
  stopOpacity: 0.15
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#313866",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-30",
  x1: -1758.5,
  y1: 579.76,
  x2: -1744.86,
  y2: 582.31,
  xlinkHref: "#run_svg__linear-gradient-29"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-31",
  x1: -1758.18,
  y1: 578.04,
  x2: -1744.54,
  y2: 580.59,
  xlinkHref: "#run_svg__linear-gradient-29"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-32",
  x1: -1768.59,
  y1: 591.51,
  x2: -1779.69,
  y2: 570.22,
  xlinkHref: "#run_svg__linear-gradient-28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-33",
  x1: -266.98,
  y1: 1424.28,
  x2: -241.55,
  y2: 1424.28,
  gradientTransform: "rotate(48 1514.578 1789.296)",
  xlinkHref: "#run_svg__linear-gradient-28"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-34",
  x1: 340.52,
  y1: 1498.97,
  x2: 360.63,
  y2: 1538.08,
  gradientTransform: "translate(0 -1179.45)",
  xlinkHref: "#run_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-35",
  x1: 367.2,
  y1: 1509.91,
  x2: 393.71,
  y2: 1547.31,
  gradientTransform: "translate(0 -1179.45)",
  xlinkHref: "#run_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-36",
  x1: 925.41,
  y1: -515.73,
  x2: 946.14,
  y2: -482.92,
  xlinkHref: "#run_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-37",
  x1: 907.38,
  y1: -522.42,
  x2: 928.11,
  y2: -489.6,
  xlinkHref: "#run_svg__linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-38",
  x1: 333.56,
  y1: 1355.01,
  x2: 310.1,
  y2: 1368.51,
  gradientTransform: "translate(0 -1179.45)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#101436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.64,
  stopColor: "#27335c",
  stopOpacity: 0.35
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#31406b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "run_svg__linear-gradient-39",
  x1: 387.34,
  y1: 1344.21,
  x2: 326,
  y2: 1408.37,
  xlinkHref: "#run_svg__linear-gradient-38"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M570.25 378.61L289.32 216.17V29.75c0-2.56 1.37-3.35 3.59-2.07l270.88 157.08c2.87 1.66 6.46 7.87 6.46 11.18z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M330.8 108.34c2.55 1.45 4.62 5.38 4.62 8.77s-2.07 5-4.62 3.5-4.62-5.38-4.62-8.77 2.07-4.96 4.62-3.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M334 121.85c.51.29.93 0 .93-.71a2.2 2.2 0 00-.93-1.75c-.51-.29-.92 0-.92.7a2.21 2.21 0 00.92 1.76zm-5.54-11.76l11.09 6.32v14.74l-11.08-6.33z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-4"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-2",
  cx: 334.03,
  cy: 120.62,
  rx: 0.8,
  ry: 1.41,
  transform: "rotate(-23.13 334.081 120.628)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M328.49 124.82l11.08 6.33.01-14.74-11.09-6.32v14.73z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-6"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M333.11 121.32l1.85 1.05v-2.45l-1.85-1.06v2.46z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-9"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M333.11 118.86l1.85 1.06v2.45l-1.85-1.05v-2.46z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-11"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M330.79 132.89c2.56 1.46 4.62 5.38 4.62 8.77s-2.07 5-4.62 3.51-4.62-5.39-4.62-8.78 2.07-4.95 4.62-3.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-12"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M334 146.4c.51.29.93 0 .93-.7a2.18 2.18 0 00-.93-1.76c-.51-.29-.92 0-.92.7a2.19 2.19 0 00.92 1.76zm-5.54-11.76l11.11 6.36v14.7l-11.09-6.33z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-13"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-2",
  cx: 334.02,
  cy: 145.17,
  rx: 0.8,
  ry: 1.41,
  transform: "rotate(-23.13 334.07 145.191)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-14"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M328.48 149.38l11.09 6.32v-14.73l-11.09-6.33v14.74z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-15"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M333.1 145.87l1.85 1.06v-2.46l-1.85-1.05v2.45z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-18"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M333.1 143.42l1.85 1.05v2.46l-1.85-1.06v-2.45z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-20"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M331.13 182.89c2.55 1.46 4.62 5.38 4.62 8.77s-2.07 5-4.63 3.51-4.62-5.39-4.61-8.78 2.07-4.96 4.62-3.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-21"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M334.36 196.4c.51.29.92 0 .92-.7a2.19 2.19 0 00-.92-1.76c-.51-.29-.93 0-.93.7a2.2 2.2 0 00.93 1.76zm-5.54-11.76l11.09 6.36v14.7l-11.09-6.33z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-22"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-2",
  cx: 334.36,
  cy: 195.17,
  rx: 0.8,
  ry: 1.41,
  transform: "rotate(-23.13 334.405 195.181)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-23"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M328.81 199.37l11.09 6.33v-14.73l-11.08-6.33-.01 14.73z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-24"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M333.43 195.87l1.85 1.05v-2.45l-1.84-1.06-.01 2.46z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-27"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M333.44 193.41l1.84 1.06v2.45l-1.85-1.05.01-2.46z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-29"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M331.13 207.18c2.55 1.45 4.62 5.38 4.62 8.77s-2.07 5-4.63 3.5-4.62-5.38-4.61-8.77 2.07-4.96 4.62-3.5z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-30"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M334.36 220.68c.51.3.92 0 .92-.7a2.19 2.19 0 00-.92-1.75c-.51-.29-.93 0-.93.7a2.18 2.18 0 00.93 1.75zm-5.54-11.75l11.09 6.32V230l-11.09-6.32z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-31"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 334.36,
  cy: 219.46,
  rx: 0.8,
  ry: 1.41,
  transform: "rotate(-23.13 334.4 219.466)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-32"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M328.81 223.66l11.09 6.32v-14.73l-11.08-6.32-.01 14.73z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-33"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-2",
  d: "M333.43 220.16l1.85 1.05v-2.45l-1.84-1.06-.01 2.46z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "run_svg__clip-path-36"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-3",
  d: "M333.44 217.7l1.84 1.06v2.45l-1.85-1.05.01-2.46z"
})), /*#__PURE__*/React.createElement("mask", {
  id: "run_svg__mask",
  x: 298.53,
  y: 181.62,
  width: 7.44,
  height: 12.88,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__mask-177"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-176",
  className: "run_svg__cls-1",
  d: "M302.57 185.61a3.84 3.84 0 01.93.74 5.1 5.1 0 01.73 1 5.73 5.73 0 01.48 1.14 4.36 4.36 0 01.17 1.17 2.27 2.27 0 01-.2 1 1.21 1.21 0 01-.52.59 1.32 1.32 0 01-.78.16 2.32 2.32 0 01-.95-.32 4.64 4.64 0 01-.93-.75 5.11 5.11 0 01-.74-1 4.9 4.9 0 01-.49-1.13 4.14 4.14 0 01-.18-1.19.11.11 0 01.05-.1.09.09 0 01.11 0 .34.34 0 01.12.12.37.37 0 01.05.16 3.6 3.6 0 00.15 1 4.46 4.46 0 00.42 1 4.4 4.4 0 00.64.85 3.42 3.42 0 00.8.63 2 2 0 00.83.29 1.14 1.14 0 00.67-.14 1.13 1.13 0 00.45-.51 2 2 0 00.17-.86 3.58 3.58 0 00-.15-1 4.31 4.31 0 00-.4-1 4.8 4.8 0 00-.63-.85 3.42 3.42 0 00-.8-.63.51.51 0 01-.12-.13.29.29 0 010-.16.12.12 0 010-.11.11.11 0 01.12.03zm-.49 1.82a.13.13 0 01-.05.11h-.12l-2.13-1.23a.34.34 0 01-.12-.12.37.37 0 01-.05-.17 2.17 2.17 0 01.18-.93 1.18 1.18 0 01.49-.56 1.25 1.25 0 01.73-.15 2.25 2.25 0 01.9.31.3.3 0 01.12.13.33.33 0 01.05.16zm-.33-.38V185a1.86 1.86 0 00-.68-.18 1.09 1.09 0 00-.55.13.89.89 0 00-.39.42 1.7 1.7 0 00-.18.68z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "run_svg__mask-2",
  x: 298.53,
  y: 153,
  width: 7.44,
  height: 12.88,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__mask-179"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-178",
  className: "run_svg__cls-1",
  d: "M299.28 156.26a.5.5 0 01-.08-.12.78.78 0 010-.14.17.17 0 010-.1.1.1 0 01.08 0h2.99a.28.28 0 01.09.07l2.87 3.35a.29.29 0 01.07.12.35.35 0 010 .13.2.2 0 010 .11.08.08 0 01-.06 0l-2.92.13h-.1zm3 .1h-2.48l2.45 3 2.49-.11zm2.93 4.57a.35.35 0 01.08.13.35.35 0 010 .13.17.17 0 010 .1.07.07 0 01-.07 0l-2.91.13h-.05a.12.12 0 01-.05-.05l-2.88-3.46a.54.54 0 01-.07-.13.69.69 0 010-.13.22.22 0 010-.1.09.09 0 01.08 0h.61l.41.5h-.51l2.45 3 2.49-.11-.48-.57h.41zm0 1.56a.35.35 0 01.08.13.35.35 0 010 .13.15.15 0 010 .1.07.07 0 01-.07 0l-2.91.14h-.05l-.05-.05-2.88-3.47a.47.47 0 01-.07-.12.78.78 0 010-.14.3.3 0 010-.1.11.11 0 01.08 0h.57l.42.49h-.48l2.45 3 2.49-.11-.45-.52h.41z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "run_svg__mask-3",
  x: 298.53,
  y: 124.39,
  width: 7.44,
  height: 12.88,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__mask-181"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-180",
  className: "run_svg__cls-1",
  d: "M301.31 127.07v.71l1.86 1.08v-.72l.62.36v.72l.62.35a1.38 1.38 0 01.62 1.08v3.93c0 .4-.28.56-.62.36l-4.33-2.5a1.36 1.36 0 01-.62-1.08v-3.93c0-.4.27-.56.62-.36l.62.36v-.72zm3.1 2.86l-4.33-2.5c-.18-.1-.31 0-.31.18v3.93a.67.67 0 00.31.54l4.33 2.5c.17.1.31 0 .31-.18v-3.93a.69.69 0 00-.31-.54zm-2.17-.18V131l.93 1.17-.15.2-1.09-1.37v-1.41z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "run_svg__mask-4",
  x: 298.53,
  y: 95.77,
  width: 7.44,
  height: 12.88,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__mask-183"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-182",
  className: "run_svg__cls-1",
  d: "M302.71 99.7l-2 2 1.69 1-.06.39-.34 1.79 2-2-1.69-1 .06-.39zm.58-1.18l-.6 3.23 1.93 1.11-3.22 3.14.61-3.22-1.93-1.12z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "run_svg__mask-5",
  x: 298.53,
  y: 67.15,
  width: 7.44,
  height: 12.88,
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__mask-185"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-184",
  className: "run_svg__cls-1",
  d: "M300.79 70.25a.41.41 0 00-.08.22v.08l-.6-.35v5.37l4.29 2.48v-5.37l-.6-.34a.77.77 0 00-.07-.32v-.06l.69.4a.7.7 0 01.33.54v5.37c0 .2-.15.27-.33.17l-4.29-2.48a.69.69 0 01-.33-.55V70c0-.19.14-.27.33-.16zm2.7 5.49a.35.35 0 01.15.26c0 .1-.07.15-.15.1L301 74.66a.35.35 0 01-.15-.26c0-.1.07-.15.15-.1zm0-1.07a.32.32 0 01.15.26c0 .1-.07.14-.15.1L301 73.59a.36.36 0 01-.15-.27c0-.1.07-.14.15-.09zm0-1.08a.36.36 0 01.15.27c0 .1-.07.14-.15.09L301 72.51a.32.32 0 01-.15-.26c0-.1.07-.14.15-.1zM302.24 70a1.73 1.73 0 01.78 1.16 5.25 5.25 0 01.62 1c0 .2-.14.28-.31.18l-2.17-1.25a.69.69 0 01-.31-.54c0-.08.21-.19.62-.33.07-.31.39-.43.77-.22zm0 .54c-.17-.1-.31 0-.31.18a.66.66 0 00.31.53c.18.1.31 0 .31-.17a.67.67 0 00-.31-.53z"
}))), /*#__PURE__*/React.createElement("style", null, ".run_svg__cls-1,.run_svg__cls-32{fill:#fff}.run_svg__cls-1,.run_svg__cls-72,.run_svg__cls-74{fill-rule:evenodd}.run_svg__cls-2,.run_svg__cls-3{fill:none}.run_svg__cls-3{clip-rule:evenodd}.run_svg__cls-5{fill:#acb0bb}.run_svg__cls-11{fill:#2d327e}.run_svg__cls-13{fill:#5c71b3}.run_svg__cls-21{fill:#ec6977}.run_svg__cls-37{fill:#25c084}.run_svg__cls-39{fill:#373b46}.run_svg__cls-40{clip-path:url(#run_svg__clip-path-3)}.run_svg__cls-42{isolation:isolate}.run_svg__cls-44{clip-path:url(#run_svg__clip-path-6)}.run_svg__cls-45{opacity:.5}.run_svg__cls-46{fill:#6674b1}.run_svg__cls-49{clip-path:url(#run_svg__clip-path-12)}.run_svg__cls-52{clip-path:url(#run_svg__clip-path-15)}.run_svg__cls-55{clip-path:url(#run_svg__clip-path-21)}.run_svg__cls-58{clip-path:url(#run_svg__clip-path-24)}.run_svg__cls-61{clip-path:url(#run_svg__clip-path-30)}.run_svg__cls-64{clip-path:url(#run_svg__clip-path-33)}.run_svg__cls-66{opacity:.8}.run_svg__cls-67{opacity:.7}.run_svg__cls-68{opacity:.62}.run_svg__cls-71,.run_svg__cls-72{fill:#b7c2da}.run_svg__cls-74{fill:#08c47f}.run_svg__cls-80{fill:#006854}.run_svg__cls-81{fill:#bf0247}.run_svg__cls-82{fill:#f70057}.run_svg__cls-102{fill:#bf7b43}.run_svg__cls-103{fill:#df1d39}.run_svg__cls-105{fill:#101436}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient)",
  d: "M558.7 401.8L359.87 520.04l156.46 90.34 198.83-118.25L558.7 401.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-2)",
  d: "M248.54 213.27l-125.71 76.58 156.47 90.34L405 303.6l-156.46-90.33z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.64 247.51L0 176.21v38.58a7.53 7.53 0 003.76 6.53l115.88 66.95a22.64 22.64 0 0022.76 0l115-66.62a7.47 7.47 0 003.76-6.53v-39L142.4 247.44a22.48 22.48 0 01-22.76.07z",
  fill: "url(#run_svg__linear-gradient-3)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.64 247.51l-117.73-68a3.84 3.84 0 010-6.6l116.81-67.47a22.62 22.62 0 0122.75 0l117.73 68a3.77 3.77 0 010 6.53l-116.8 67.47a22.48 22.48 0 01-22.76.07z",
  fill: "url(#run_svg__linear-gradient-4)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131 251.86a23.69 23.69 0 01-12-3.23l-117.73-68 1.32-2.31 117.73 68a21.49 21.49 0 0021.44 0l116.81-67.47 1.31 2.31-116.8 67.47a23.93 23.93 0 01-12.08 3.23z",
  fill: "url(#run_svg__linear-gradient-5)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-11",
  cx: 11.93,
  cy: 206.21,
  rx: 3.96,
  ry: 6.86,
  transform: "rotate(-30.34 11.946 206.236)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-11",
  cx: 27.7,
  cy: 215.31,
  rx: 3.96,
  ry: 6.86,
  transform: "rotate(-30.34 27.71 215.34)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.4 272.7l-73.67-42.61V219l73.67 42.54z",
  fill: "url(#run_svg__linear-gradient-6)"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-13",
  d: "M145.17 272.7l107.64-62.13v-5.08l-107.64 62.07zm0-8.38l107.64-62.06v-5.14l-107.64 62.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.64 194.48L0 123.18v38.58a7.73 7.73 0 003.76 6.6l115.88 66.94a22.64 22.64 0 0022.76 0l115-66.61a7.42 7.42 0 003.76-6.53v-39L142.4 194.48a23 23 0 01-22.76 0z",
  fill: "url(#run_svg__linear-gradient-7)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.64 194.48l-117.73-68a3.84 3.84 0 010-6.6l116.81-67.47a22.62 22.62 0 0122.75 0l117.73 68.07a3.82 3.82 0 010 6.59l-116.8 67.41a23 23 0 01-22.76 0z",
  fill: "url(#run_svg__linear-gradient-8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M131 199a24.16 24.16 0 01-12.14-3.23L1.12 127.8l1.52-2.64 117.79 68a21.41 21.41 0 0021.24 0l116.81-67.47 1.52 2.63-116.88 67.48A24.55 24.55 0 01131 199z",
  fill: "url(#run_svg__linear-gradient-9)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-11",
  cx: 11.94,
  cy: 153.18,
  rx: 3.96,
  ry: 6.86,
  transform: "rotate(-30.34 11.953 153.202)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-11",
  cx: 27.71,
  cy: 162.28,
  rx: 3.96,
  ry: 6.86,
  transform: "rotate(-30.34 27.718 162.307)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M117.4 219.61l-73.67-42.54v-11.15l73.67 42.54z",
  fill: "url(#run_svg__linear-gradient-10)"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-13",
  d: "M145.17 219.61l107.64-62.07v-5.14l-107.64 62.13zm0-8.31l107.64-62.13v-5.08l-107.64 62.13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M590.29 260l1.25 12.83 2.14 1.33s-3.89 8.31-1.68 11.84 7.64 4.62 7.64 4.62l-1.12-3.37 4 .42-1.33-2.81 3.95-.63-5.59-2.68s10.91-11.71 4-17.46a18.81 18.81 0 00-13.26-4.09z",
  fill: "url(#run_svg__linear-gradient-11)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-12)",
  d: "M147.35 445.83l-17.79-10.39 50.85-29.36 17.8 10.39-50.86 29.36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-13)",
  d: "M133.12 435.63l-17.8-10.39 50.86-29.36 17.79 10.39-50.85 29.36z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-21",
  d: "M121.48 444.86l80.34-46.38-79.78-46.07L41.7 398.8l79.78 46.06z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-21",
  d: "M121.48 444.86l80.34-46.38-79.78-46.07L41.7 398.8l79.78 46.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f7c963",
  d: "M142.68 443.34l80.34-46.38-79.79-46.07-80.34 46.39 79.79 46.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-14)",
  d: "M142.68 443.34l80.34-46.38-79.79-46.07-80.34 46.39 79.79 46.06z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384 515.61l196-114.93v14.83a3 3 0 01-1.52 2.63L384 530.42a7.59 7.59 0 01-7.59 0l-298.6-172.3a3 3 0 01-1.52-2.63v-15.23l300.1 175.35a7.62 7.62 0 007.61 0z",
  fill: "url(#run_svg__linear-gradient-15)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M384 515.61l194.5-112.3a3 3 0 000-5.26L279.89 225.82a7.55 7.55 0 00-7.58 0L77.8 338.11a3 3 0 000 5.26l298.59 172.24a7.62 7.62 0 007.61 0z",
  fill: "url(#run_svg__linear-gradient-16)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.81 343.37l298.58 172.24a7.62 7.62 0 007.59 0l194.5-112.3",
  stroke: "url(#run_svg__linear-gradient-17)",
  strokeWidth: 2.34,
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M196.77 384.11l49.63-28.66a12.13 12.13 0 0112.14 0l93.78 54.09a4.55 4.55 0 010 7.89l-49.63 28.66a12.13 12.13 0 01-12.14 0L196.77 392a4.56 4.56 0 010-7.89z",
  fill: "url(#run_svg__linear-gradient-18)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M352.32 417.43l-49.63 28.66a12.13 12.13 0 01-12.14 0L196.77 392",
  stroke: "url(#run_svg__linear-gradient-19)",
  strokeWidth: 2.34,
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M288 .41a3 3 0 013 0l298.74 172.28a7.6 7.6 0 013.8 6.58v210.08A3.05 3.05 0 01592 392l-10.75 6.2L583 185.32a7.58 7.58 0 00-3.8-6.57L277.52 6.44z",
  fill: "url(#run_svg__linear-gradient-20)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M579.24 178.75L280.65 6.51a3 3 0 00-4.55 2.63v210.1a7.59 7.59 0 003.79 6.58l298.59 172.23a3 3 0 004.56-2.63v-210.1a7.58 7.58 0 00-3.8-6.57z",
  fill: "url(#run_svg__linear-gradient-21)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M583 395.42v-210.1a7.58 7.58 0 00-3.8-6.57L280.65 6.51",
  stroke: "url(#run_svg__linear-gradient-22)",
  strokeWidth: 2.34,
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M567.85 188L292 28.85a1.52 1.52 0 00-2.28 1.32V214a3 3 0 001.52 2.63L567.1 375.71a1.51 1.51 0 002.27-1.31V190.58a3.05 3.05 0 00-1.52-2.58z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#3a3f4c",
  d: "M314.04 230.34l-24.72-14.17V25.61l24.72 6.34v198.39z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-23)",
  d: "M556.3 232.49L323.76 98.45v-1.29L556.3 231.2v1.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M337.38 105.1l-13.62-7.77v-.92l13.62 7.76v.93z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-24)",
  d: "M556.27 306.73L323.74 172.69v-1.29l232.53 134.04v1.29z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-37",
  d: "M347.49 185.12l-23.75-13.55v-.93l23.75 13.55v.93z"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-39",
  d: "M325.02 118.86l11.55 6.58.01-15.34-11.55-6.59-.01 15.35z"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-40"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334 122.46a3.31 3.31 0 01-1.38-2.63c0-1 .62-1.49 1.38-1a3.26 3.26 0 011.39 2.63c.03.96-.59 1.44-1.39 1zm0-2.46c-.25-.14-.46 0-.46.35a1.1 1.1 0 00.46.88c.26.15.46 0 .46-.35a1.09 1.09 0 00-.46-.88z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-4)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-5)"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-44"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-45"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-46",
  d: "M331.95 122.19l4.16 2.38v-5.53l-4.16-2.37v5.52z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-40"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-44"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334 122.46a3.31 3.31 0 01-1.38-2.63c0-1 .62-1.49 1.38-1a3.26 3.26 0 011.39 2.63c.03.96-.59 1.44-1.39 1zm0-2.46c-.25-.14-.46 0-.46.35a1.1 1.1 0 00.46.88c.26.15.46 0 .46-.35a1.09 1.09 0 00-.46-.88z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-44",
  clipPath: "url(#run_svg__clip-path-9)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M331.95 122.19l4.16 2.38v-5.53l-4.16-2.37v5.52z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-11)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-39",
  d: "M325.01 143.41l11.55 6.59.01-15.35-11.55-6.59-.01 15.35z"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-49"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334 147a3.28 3.28 0 01-1.38-2.63c0-1 .62-1.49 1.39-1a3.31 3.31 0 011.38 2.63c.02 1-.6 1.45-1.39 1zm0-2.45c-.25-.15-.46 0-.46.35a1.08 1.08 0 00.46.87c.26.15.47 0 .47-.35a1.08 1.08 0 00-.47-.86z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-13)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-14)"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-52"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-45"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-46",
  d: "M331.94 146.75l4.16 2.37.01-5.53-4.16-2.37-.01 5.53z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-49"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-52"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334 147a3.28 3.28 0 01-1.38-2.63c0-1 .62-1.49 1.39-1a3.31 3.31 0 011.38 2.63c.02 1-.6 1.45-1.39 1zm0-2.45c-.25-.15-.46 0-.46.35a1.08 1.08 0 00.46.87c.26.15.47 0 .47-.35a1.08 1.08 0 00-.47-.86z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-52",
  clipPath: "url(#run_svg__clip-path-18)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M331.94 146.75l4.16 2.37.01-5.53-4.16-2.37-.01 5.53z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-20)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-39",
  d: "M325.35 193.41L336.9 200v-15.35l-11.55-6.59v15.35z"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-55"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334.36 197a3.27 3.27 0 01-1.39-2.63c0-1 .62-1.49 1.39-1a3.28 3.28 0 011.38 2.63c0 1-.62 1.45-1.38 1zm0-2.45c-.26-.15-.46 0-.46.35a1.07 1.07 0 00.46.87c.25.15.46 0 .46-.35a1.1 1.1 0 00-.46-.86z"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-22)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-23)"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-58"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-45"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-46",
  d: "M332.28 196.75l4.16 2.37v-5.53l-4.16-2.37v5.53z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-55"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-58"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334.36 197a3.27 3.27 0 01-1.39-2.63c0-1 .62-1.49 1.39-1a3.28 3.28 0 011.38 2.63c0 1-.62 1.45-1.38 1zm0-2.45c-.26-.15-.46 0-.46.35a1.07 1.07 0 00.46.87c.25.15.46 0 .46-.35a1.1 1.1 0 00-.46-.86z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-58",
  clipPath: "url(#run_svg__clip-path-27)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-37",
  d: "M332.28 196.75l4.16 2.37v-5.53l-4.16-2.37v5.53z"
})))), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-29)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-39",
  d: "M325.35 217.69l11.55 6.59v-15.34l-11.55-6.59v15.34z"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-61"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334.36 221.3a3.29 3.29 0 01-1.39-2.63c0-1 .62-1.49 1.39-1.06a3.31 3.31 0 011.38 2.64c0 1.01-.62 1.48-1.38 1.05zm0-2.46c-.26-.14-.46 0-.46.35a1.09 1.09 0 00.46.88c.25.15.46 0 .46-.35a1.12 1.12 0 00-.46-.88z"
})), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 334.36,
  cy: 219.46,
  rx: 0.8,
  ry: 1.41,
  transform: "rotate(-23.13 334.4 219.466)"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-31)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#run_svg__clip-path-32)"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-64"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-45"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-46",
  d: "M332.28 221.03l4.16 2.37v-5.52l-4.16-2.37v5.52z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-61"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-64"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M334.36 221.3a3.29 3.29 0 01-1.39-2.63c0-1 .62-1.49 1.39-1.06a3.31 3.31 0 011.38 2.64c0 1.01-.62 1.48-1.38 1.05zm0-2.46c-.26-.14-.46 0-.46.35a1.09 1.09 0 00.46.88c.25.15.46 0 .46-.35a1.12 1.12 0 00-.46-.88z"
}))), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-64",
  clipPath: "url(#run_svg__clip-path-36)"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-37",
  d: "M332.28 221.03l4.16 2.37v-5.52l-4.16-2.37v5.52z"
})))), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M340.85 126.57l15.73 9c.2.11.35 0 .35-.26v-2.57a.8.8 0 00-.35-.66l-15.73-9c-.19-.11-.35 0-.35.27v2.56a.84.84 0 00.35.66z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-39",
  d: "M340.85 120.82l20.4 11.63c.19.11.35 0 .35-.27v-2.56a.84.84 0 00-.35-.67l-20.4-11.63c-.19-.11-.35 0-.35.27v2.56a.84.84 0 00.35.67z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-37",
  d: "M324.08 93.77l13 7.41c.17.1.31 0 .31-.24v-3.59a.76.76 0 00-.31-.6l-13-7.4c-.18-.1-.32 0-.32.24v3.58a.74.74 0 00.32.6zm.08 74.05l22.91 13.06c.23.14.42 0 .42-.31v-3.32a1 1 0 00-.42-.79l-22.91-13.07c-.23-.13-.42 0-.42.32V167a1 1 0 00.42.82z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M353.8 184.72l17.89 10.21c.23.13.42 0 .42-.32v-3.31a1 1 0 00-.41-.8l-17.9-10.2c-.23-.14-.42 0-.42.31v3.32a1 1 0 00.42.79z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-39",
  d: "M340.84 144.53l20.4 11.63c.19.11.35 0 .35-.26v-2.57a.82.82 0 00-.35-.66L340.84 141c-.19-.11-.34 0-.34.26v2.57a.84.84 0 00.34.7zm-.01 50.19l20.39 11.63c.2.11.35 0 .35-.27v-2.56a.82.82 0 00-.35-.67l-20.39-11.63c-.19-.11-.35 0-.35.27v2.56a.84.84 0 00.35.67zm-.01 24.28l20.4 11.64c.19.11.35 0 .35-.27v-2.57a.84.84 0 00-.35-.66l-20.4-11.63c-.19-.11-.35 0-.35.26v2.57a.82.82 0 00.35.66z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M340.83 200.61l15.73 9c.19.11.35 0 .35-.27v-2.56a.84.84 0 00-.35-.67l-15.73-9c-.2-.11-.35 0-.35.27v2.56a.82.82 0 00.35.67zm-.01 24.24l15.73 9c.2.11.35 0 .35-.27V231a.81.81 0 00-.35-.66l-15.73-9c-.19-.11-.35 0-.35.26v2.57a.82.82 0 00.35.68zm34.81-84.14l25.46 14.51c.19.11.35 0 .35-.26v-2.57a.8.8 0 00-.35-.66l-25.46-14.52c-.19-.11-.35 0-.35.27V140a.84.84 0 00.35.71z"
}), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-66"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-67"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M385.14 154.08l-7.94-4.53a5.39 5.39 0 01-2.27-4.31c0-1.66 1-2.43 2.27-1.72l7.94 4.53a5.38 5.38 0 012.27 4.31c0 1.64-1.02 2.43-2.27 1.72zm-7.94-9.63c-.87-.5-1.57 0-1.57 1.19a3.71 3.71 0 001.57 3l7.94 4.53c.86.5 1.57 0 1.57-1.19a3.71 3.71 0 00-1.57-3z"
}))), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M375.62 164.42l25.46 14.52c.2.11.35 0 .35-.27v-2.57a.83.83 0 00-.34-.66l-25.47-14.51c-.19-.11-.35 0-.35.26v2.57a.82.82 0 00.35.66z"
}), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-66"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-67"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M385.13 177.79l-7.94-4.52a5.41 5.41 0 01-2.27-4.32c0-1.66 1-2.43 2.27-1.72l7.94 4.53a5.41 5.41 0 012.27 4.31c0 1.67-1.02 2.44-2.27 1.72zm-7.94-9.63c-.86-.49-1.57 0-1.57 1.19a3.74 3.74 0 001.57 3l7.94 4.53c.87.49 1.57 0 1.57-1.2a3.71 3.71 0 00-1.57-3z"
}))), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M375.61 214.61l25.46 14.51c.19.11.35 0 .35-.26v-2.57a.82.82 0 00-.35-.66l-25.46-14.52c-.2-.11-.35 0-.35.27v2.56a.82.82 0 00.35.67zm-.01 24.27l19.28 11c.19.11.35 0 .35-.27V247a.81.81 0 00-.35-.66l-19.28-11c-.19-.11-.35 0-.35.26v2.57a.84.84 0 00.35.71z"
}), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-66"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-67"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M385.11 252.25l-7.94-4.53a5.41 5.41 0 01-2.27-4.31c0-1.66 1-2.44 2.27-1.72l7.94 4.53a5.38 5.38 0 012.27 4.31c0 1.66-1.02 2.47-2.27 1.72zm-7.94-9.64c-.87-.49-1.57 0-1.57 1.2a3.71 3.71 0 001.57 3l7.94 4.53c.86.49 1.57 0 1.57-1.19a3.74 3.74 0 00-1.57-3z"
}))), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M340.84 150.81l15.74 9c.19.11.35 0 .35-.26V157a.84.84 0 00-.35-.67l-15.74-9c-.19-.11-.35 0-.35.27v2.56a.84.84 0 00.35.65z"
}), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-67"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M550.15 247.7c-2.79-1.58-5-5.88-5-9.57s2.27-5.41 5-3.83 5 5.89 5 9.58-2.22 5.41-5 3.82zm0-12.47c-2.4-1.36-4.35.11-4.35 3.3s2 6.88 4.35 8.25 4.34-.12 4.34-3.3-1.94-6.88-4.34-8.25z"
})), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M549.23 242.16l1.83 1.05c.2.11.35 0 .35-.27v-2.43a.84.84 0 00-.34-.67l-1.84-1c-.19-.11-.35 0-.35.26v2.44a.82.82 0 00.35.62z"
}), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-67"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M550.14 272.25c-2.78-1.59-5-5.89-5-9.58s2.26-5.41 5-3.82 5.05 5.88 5 9.57-2.22 5.41-5 3.83zm0-12.48c-2.39-1.36-4.34.12-4.34 3.3s1.94 6.88 4.34 8.25 4.34-.11 4.34-3.3-1.94-6.88-4.34-8.25z"
})), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M549.22 266.7l1.84 1.05c.19.11.35 0 .35-.26v-2.44a.82.82 0 00-.35-.66l-1.84-1.05c-.19-.11-.35 0-.35.27V266a.82.82 0 00.35.7z"
}), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 508.01,
  cy: 291.63,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 508.064 291.636)"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 518.67,
  cy: 297.71,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 518.73 297.74)"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 508,
  cy: 315.48,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 508.065 315.515)"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 518.66,
  cy: 321.56,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 518.735 321.594)"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 518.7,
  cy: 223.02,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 518.768 223.03)"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 508.03,
  cy: 216.94,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 508.098 216.953)"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 518.69,
  cy: 247.58,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 518.757 247.595)"
})), /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-68"
}, /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 508.02,
  cy: 241.5,
  rx: 3.06,
  ry: 5.37,
  transform: "rotate(-23.13 508.087 241.516)"
})), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-5",
  d: "M323 57.34v5.34a3 3 0 001.1 1.91l20.38 11.81c.65.38 1 .15 1-.59v-5.57a3 3 0 00-1.11-1.92l-20.3-11.57c-.64-.37-1.07-.14-1.07.59z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M543.12 184.74v4.83a2.68 2.68 0 001 1.73l16.62 9.57c.58.35.94.14.94-.53v-5.05a2.68 2.68 0 00-1-1.73l-16.62-9.36c-.58-.33-.94-.13-.94.54z",
  fill: "#e4778f"
}), /*#__PURE__*/React.createElement("path", {
  d: "M314.04 67.98l-24.72-14.16m280.93 162.45L314.04 67.98",
  stroke: "#acb0bb",
  strokeWidth: 0.79,
  strokeMiterlimit: 10,
  fill: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 531.7,
  cy: 180.29,
  rx: 3.71,
  ry: 6.55,
  transform: "rotate(-23.2 531.826 180.32)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 519.66,
  cy: 173.35,
  rx: 3.71,
  ry: 6.55,
  transform: "rotate(-23.2 519.777 173.354)"
}), /*#__PURE__*/React.createElement("ellipse", {
  className: "run_svg__cls-5",
  cx: 507.63,
  cy: 166.4,
  rx: 3.71,
  ry: 6.55,
  transform: "rotate(-23.2 507.747 166.417)"
})), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Label",
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-71",
  d: "M296.77 194.43l-.32-.19v1.2l-.45-.26v-3l1 .58a1.69 1.69 0 01.82 1.4c0 .43-.23.63-.59.52l.59 1.6-.5-.29zm.15-.37c.28.16.46.08.46-.2a.87.87 0 00-.46-.73l-.47-.28v.93zm2.89 2.72c-.1.31-.38.44-.82.19a2 2 0 01-.92-1.65c0-.66.42-.85.88-.59a1.83 1.83 0 01.88 1.59 1.48 1.48 0 010 .16l-1.32-.77a1 1 0 00.49.83c.26.15.4.07.45-.1zm-.41-.91a.88.88 0 00-.45-.72c-.27-.16-.43 0-.44.21zm.85 2.58v-2.91l.41.24v.29c.09-.13.3-.16.58 0a1.83 1.83 0 01.83 1.57c0 .63-.33.91-.85.61a1.44 1.44 0 01-.55-.61v1.05zm.91-2c-.29-.16-.49 0-.49.37a1.1 1.1 0 00.49.94c.28.16.48 0 .48-.38a1.08 1.08 0 00-.48-.92zm3.07 2.43c0 .65-.4.88-.94.57a2 2 0 01-.94-1.65c0-.64.4-.88.94-.57a2 2 0 01.94 1.65zm-.44-.25a1.14 1.14 0 00-.5-.95c-.27-.15-.51-.06-.51.37a1.11 1.11 0 00.51.95c.26.16.5.07.5-.37zm1.91.56l-.14-.1c-.33-.19-.49-.06-.49.33v1l-.43-.25v-2.09l.42.24v.34c.09-.18.29-.2.53-.06l.11.08zm.99.07l.37.22v.44l-.37-.22v1a.41.41 0 00.23.4l.15.07v.41a.7.7 0 01-.27-.11 1.07 1.07 0 01-.54-.93v-1l-.33-.19v-.45l.09.06c.19.11.28 0 .28-.17v-.31l.39.22zm1.06 2.02a.77.77 0 00.37.57c.18.1.27 0 .27-.09a.5.5 0 00-.21-.35l-.27-.22a1.25 1.25 0 01-.49-.89c0-.37.29-.51.67-.29a1.42 1.42 0 01.7 1l-.37-.09a.68.68 0 00-.33-.5c-.15-.09-.26 0-.26.09a.44.44 0 00.18.32l.28.22a1.3 1.3 0 01.52.94c0 .32-.23.54-.69.27a1.48 1.48 0 01-.74-1.06z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Icons_sidebar_reports",
  "data-name": "Icons/sidebar/reports"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Reports"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-176-2",
  "data-name": "path-176",
  className: "run_svg__cls-72",
  d: "M302.57 185.61a3.84 3.84 0 01.93.74 5.1 5.1 0 01.73 1 5.73 5.73 0 01.48 1.14 4.36 4.36 0 01.17 1.17 2.27 2.27 0 01-.2 1 1.21 1.21 0 01-.52.59 1.32 1.32 0 01-.78.16 2.32 2.32 0 01-.95-.32 4.64 4.64 0 01-.93-.75 5.11 5.11 0 01-.74-1 4.9 4.9 0 01-.49-1.13 4.14 4.14 0 01-.18-1.19.11.11 0 01.05-.1.09.09 0 01.11 0 .34.34 0 01.12.12.37.37 0 01.05.16 3.6 3.6 0 00.15 1 4.46 4.46 0 00.42 1 4.4 4.4 0 00.64.85 3.42 3.42 0 00.8.63 2 2 0 00.83.29 1.14 1.14 0 00.67-.14 1.13 1.13 0 00.45-.51 2 2 0 00.17-.86 3.58 3.58 0 00-.15-1 4.31 4.31 0 00-.4-1 4.8 4.8 0 00-.63-.85 3.42 3.42 0 00-.8-.63.51.51 0 01-.12-.13.29.29 0 010-.16.12.12 0 010-.11.11.11 0 01.12.03zm-.49 1.82a.13.13 0 01-.05.11h-.12l-2.13-1.23a.34.34 0 01-.12-.12.37.37 0 01-.05-.17 2.17 2.17 0 01.18-.93 1.18 1.18 0 01.49-.56 1.25 1.25 0 01.73-.15 2.25 2.25 0 01.9.31.3.3 0 01.12.13.33.33 0 01.05.16zm-.33-.38V185a1.86 1.86 0 00-.68-.18 1.09 1.09 0 00-.55.13.89.89 0 00-.39.42 1.7 1.7 0 00-.18.68z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#run_svg__mask)"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Steel_ULTRALIGHT",
  "data-name": "Color/Steel_ULTRALIGHT"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Green-Light",
  "data-name": "Color/Green-Light"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Swatch",
  className: "run_svg__cls-72",
  d: "M298.53 181.62l7.43 4.29v8.59l-7.43-4.29v-8.59z"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Label-2",
  "data-name": "Label",
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-71",
  d: "M296.44 165.29c0-1 .64-1.21 1.32-.82a2.56 2.56 0 011.19 1.67l-.42-.08a1.62 1.62 0 00-.77-1.1c-.43-.25-.87-.14-.87.6a1.91 1.91 0 00.88 1.59c.44.26.69.08.78-.21l.41.38c-.12.45-.52.71-1.19.32a2.84 2.84 0 01-1.33-2.35zm2.9 3.2v-3.11l.43.25v3.11zm1.2-2.49a.61.61 0 01.28.49c0 .18-.12.25-.28.16a.62.62 0 01-.28-.48.18.18 0 01.28-.17zm-.21 3v-2l.43.25v2.09zm2.59 1c-.1.31-.39.44-.82.19a2 2 0 01-.93-1.66c0-.66.43-.85.88-.59a1.83 1.83 0 01.89 1.6 1.42 1.42 0 010 .15l-1.33-.76a1.11 1.11 0 00.5.83c.26.15.39.06.45-.11zm-.42-.92a.87.87 0 00-.44-.72c-.27-.16-.43 0-.44.21zm1.28 1.97l-.43-.25v-2.08l.42.24v.28c.12-.17.34-.15.54 0a1.37 1.37 0 01.65 1.2v1.32l-.43-.25v-1.23a.75.75 0 00-.37-.68c-.25-.14-.38 0-.38.28zm2.22-.79l.38.22v.44l-.38-.22v1a.41.41 0 00.23.4l.15.07v.41a.63.63 0 01-.26-.11 1.05 1.05 0 01-.54-.93v-1l-.34-.19v-.45l.09.06c.2.11.28 0 .28-.17v-.31l.39.22zm1.09 2.02a.77.77 0 00.37.57c.18.1.27 0 .27-.09a.46.46 0 00-.21-.35l-.26-.22a1.23 1.23 0 01-.49-.89c0-.37.29-.51.66-.29a1.39 1.39 0 01.7 1l-.36-.09a.73.73 0 00-.34-.5c-.15-.09-.26 0-.26.09a.44.44 0 00.18.32l.28.22a1.3 1.3 0 01.52.94c0 .32-.22.54-.68.27a1.47 1.47 0 01-.75-1.06z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Icons_navigation_clients",
  "data-name": "Icons/navigation/clients"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Icons_clients",
  "data-name": "Icons/clients"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-178-2",
  "data-name": "path-178",
  className: "run_svg__cls-74",
  d: "M299.28 156.26a.5.5 0 01-.08-.12.78.78 0 010-.14.17.17 0 010-.1.1.1 0 01.08 0h2.99a.28.28 0 01.09.07l2.87 3.35a.29.29 0 01.07.12.35.35 0 010 .13.2.2 0 010 .11.08.08 0 01-.06 0l-2.92.13h-.1zm3 .1h-2.48l2.45 3 2.49-.11zm2.93 4.57a.35.35 0 01.08.13.35.35 0 010 .13.17.17 0 010 .1.07.07 0 01-.07 0l-2.91.13h-.05a.12.12 0 01-.05-.05l-2.88-3.46a.54.54 0 01-.07-.13.69.69 0 010-.13.22.22 0 010-.1.09.09 0 01.08 0h.61l.41.5h-.51l2.45 3 2.49-.11-.48-.57h.41zm0 1.56a.35.35 0 01.08.13.35.35 0 010 .13.15.15 0 010 .1.07.07 0 01-.07 0l-2.91.14h-.05l-.05-.05-2.88-3.47a.47.47 0 01-.07-.12.78.78 0 010-.14.3.3 0 010-.1.11.11 0 01.08 0h.57l.42.49h-.48l2.45 3 2.49-.11-.45-.52h.41z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#run_svg__mask-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Steel_ULTRALIGHT-2",
  "data-name": "Color/Steel_ULTRALIGHT"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Green-Light-2",
  "data-name": "Color/Green-Light"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Swatch-2",
  "data-name": "Swatch",
  className: "run_svg__cls-72",
  d: "M298.53 153l7.43 4.3v8.58l-7.43-4.29V153z"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Label-3",
  "data-name": "Label",
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-71",
  d: "M295.18 135.29a1.11 1.11 0 00-.52-.77c-.27-.15-.45-.05-.45.18a.75.75 0 00.31.57l.37.3a1.74 1.74 0 01.72 1.29c0 .47-.33.73-.93.38a2 2 0 01-1-1.52l.41.1a1.26 1.26 0 00.61 1c.31.18.47.09.47-.14a.85.85 0 00-.35-.62l-.37-.3a1.69 1.69 0 01-.67-1.24c0-.51.41-.7.9-.42a1.89 1.89 0 01.92 1.31zm1.12 1.78a1.11 1.11 0 00.51 1c.28.16.41 0 .45-.12l.38.37c-.09.28-.36.48-.83.2a2 2 0 01-.94-1.65c0-.64.4-.87.93-.57a1.79 1.79 0 01.82 1.17l-.38-.06a1 1 0 00-.44-.65c-.27-.2-.5-.11-.5.31zm2.15 2.29l-.43-.25V136l.43.25v1.21a.46.46 0 01.52 0 1.38 1.38 0 01.66 1.21V140l-.43-.25v-1.23a.75.75 0 00-.37-.68c-.24-.14-.37 0-.38.25zm3.31 1.31c-.1.31-.39.44-.82.19a2 2 0 01-.93-1.65c0-.66.43-.85.89-.59a1.83 1.83 0 01.88 1.59v.16l-1.32-.77a1 1 0 00.49.83c.26.15.39.07.45-.1zm-.42-.91a.85.85 0 00-.44-.72c-.27-.16-.43 0-.44.2zm2.52 2.34v.4l-.41-.24a2.16 2.16 0 010-.28c-.08.12-.27.16-.53 0a1.91 1.91 0 01-.87-1.6c0-.6.36-.89.86-.6a1.18 1.18 0 01.54.61v-1.26l.41.24zm-.89-.52c.28.17.48 0 .48-.39a1 1 0 00-.48-.92c-.28-.16-.49 0-.49.37a1.1 1.1 0 00.52.94zm2.11 1.67a1.45 1.45 0 01-.68-1.23v-1.31l.43.25v1.22a.78.78 0 00.37.69c.25.14.38 0 .38-.25v-1.24l.43.25v2.1l-.41-.24v-.24c-.09.14-.3.12-.52 0zm1.49.75v-3.1l.43.25v3.1zm2.59.94c-.1.31-.39.44-.82.19a2 2 0 01-.93-1.65c0-.66.43-.85.88-.59a1.81 1.81 0 01.89 1.59 1.48 1.48 0 010 .16l-1.33-.77a1.08 1.08 0 00.5.83c.26.15.39.07.45-.1zm-.42-.91a.87.87 0 00-.44-.72c-.27-.16-.43 0-.44.21zm1.07 1.2a.71.71 0 00.37.57c.17.1.27 0 .27-.09a.48.48 0 00-.22-.35l-.26-.22a1.23 1.23 0 01-.49-.89c0-.37.29-.51.67-.29a1.4 1.4 0 01.69 1l-.36-.09a.7.7 0 00-.33-.51c-.16-.09-.27 0-.27.09a.46.46 0 00.19.32l.27.23a1.26 1.26 0 01.52.93c0 .32-.22.54-.68.28a1.51 1.51 0 01-.75-1.07z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Icons_navigation_clock",
  "data-name": "Icons/navigation/clock"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Time---Icon"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-180-2",
  "data-name": "path-180",
  d: "M301.31 127.07v.71l1.86 1.08v-.72l.62.36v.72l.62.35a1.38 1.38 0 01.62 1.08v3.93c0 .4-.28.56-.62.36l-4.33-2.5a1.36 1.36 0 01-.62-1.08v-3.93c0-.4.27-.56.62-.36l.62.36v-.72zm3.1 2.86l-4.33-2.5c-.18-.1-.31 0-.31.18v3.93a.67.67 0 00.31.54l4.33 2.5c.17.1.31 0 .31-.18v-3.93a.69.69 0 00-.31-.54zm-2.17-.18V131l.93 1.17-.15.2-1.09-1.37v-1.41z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#run_svg__mask-3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Steel_ULTRALIGHT-3",
  "data-name": "Color/Steel_ULTRALIGHT"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Green-Light-3",
  "data-name": "Color/Green-Light"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Swatch-3",
  "data-name": "Swatch",
  className: "run_svg__cls-72",
  d: "M298.53 124.39l7.43 4.29v8.58l-7.43-4.29v-8.58z"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Label-4",
  "data-name": "Label",
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-71",
  d: "M297.62 109.5l-1.11-.65-.25.63-.47-.28 1-2.44.51.29 1 3.64-.49-.29zm-1-1l.81.46-.4-1.47zm2.52.55l.37.21v.44l-.37-.21v1a.41.41 0 00.23.39.85.85 0 00.15.07v.41a.6.6 0 01-.27-.1 1.1 1.1 0 01-.54-.94v-1.05l-.33-.19v-.44h.09c.19.11.28 0 .28-.16v-.32l.39.23zm1.35.78l.38.22v.44l-.38-.22v1a.42.42 0 00.23.4l.15.06v.42a1 1 0 01-.26-.11 1.07 1.07 0 01-.54-.93v-1l-.34-.2v-.44l.1.06c.19.11.27 0 .27-.17V109l.39.22zm1.26 1.62l.46.18c.11.05.14 0 .14-.07a.62.62 0 00-.34-.51c-.23-.13-.36 0-.38.16l-.39-.33c0-.34.32-.5.76-.24a1.41 1.41 0 01.77 1.22v1.35l-.4-.23a2.07 2.07 0 010-.28c-.08.11-.26.18-.55 0a1.26 1.26 0 01-.62-1c0-.31.24-.38.55-.25zm.6.67V112l-.47-.19c-.14 0-.25 0-.25.14a.52.52 0 00.27.42c.24.17.45.16.45-.25zm1.23.53a1.12 1.12 0 00.5.95c.29.16.42 0 .46-.12l.38.37c-.09.28-.36.48-.84.21a2.05 2.05 0 01-.93-1.66c0-.64.4-.87.92-.57a1.78 1.78 0 01.83 1.17l-.39-.06a1 1 0 00-.43-.65c-.27-.15-.5-.06-.5.36zm2.67 1.35l.76 1.64-.53-.3-.53-1.16-.22.14v.58l-.43-.25v-3.1l.43.25v1.86l.69-.45.57.33zm1.29 1.3a.73.73 0 00.37.57c.17.1.27 0 .27-.09a.5.5 0 00-.21-.35l-.27-.22a1.23 1.23 0 01-.49-.89c0-.37.29-.51.67-.29a1.42 1.42 0 01.7 1l-.37-.09a.67.67 0 00-.33-.51c-.16-.09-.26 0-.26.09a.44.44 0 00.18.32l.27.23a1.23 1.23 0 01.52.93c0 .32-.22.54-.68.28a1.57 1.57 0 01-.75-1.07z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Icons_navigation_bolt-",
  "data-name": "Icons/navigation/bolt-"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Icons_bolt-",
  "data-name": "Icons/bolt-"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-182-2",
  "data-name": "path-182",
  className: "run_svg__cls-74",
  d: "M302.71 99.7l-2 2 1.69 1-.06.39-.34 1.79 2-2-1.69-1 .06-.39zm.58-1.18l-.6 3.23 1.93 1.11-3.22 3.14.61-3.22-1.93-1.12z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#run_svg__mask-4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Steel_ULTRALIGHT-4",
  "data-name": "Color/Steel_ULTRALIGHT"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Green-Light-4",
  "data-name": "Color/Green-Light"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Swatch-4",
  "data-name": "Swatch",
  className: "run_svg__cls-72",
  d: "M298.53 95.77l7.43 4.29v8.59l-7.43-4.3v-8.58z"
}))))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Label-5",
  "data-name": "Label",
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("g", {
  className: "run_svg__cls-42"
}, /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-71",
  d: "M295.62 78.3a1.07 1.07 0 00-.52-.76c-.26-.16-.45-.06-.45.17a.74.74 0 00.31.57l.38.31a1.76 1.76 0 01.71 1.29c0 .47-.33.73-.93.38a2 2 0 01-1-1.52l.42.1a1.24 1.24 0 00.6 1c.31.18.48.09.48-.14a.87.87 0 00-.36-.62l-.37-.3a1.69 1.69 0 01-.67-1.24c0-.51.41-.7.9-.42a1.89 1.89 0 01.92 1.31zm1.12 1.79a1.14 1.14 0 00.51 1c.28.16.41 0 .45-.13l.38.38c-.09.28-.36.48-.83.2a2 2 0 01-.94-1.65c0-.64.41-.87.93-.57a1.78 1.78 0 01.82 1.16l-.38-.06a1 1 0 00-.44-.64c-.24-.2-.5-.11-.5.31zm3.31 2.36c-.1.31-.39.44-.82.19a2 2 0 01-.93-1.64c0-.66.43-.85.88-.59a1.83 1.83 0 01.89 1.6 1.42 1.42 0 010 .15l-1.32-.76a1.07 1.07 0 00.49.83c.26.15.39.07.45-.11zm-.42-.92a.85.85 0 00-.44-.72c-.27-.16-.43 0-.44.21zm1.28 2.01l-.43-.25v-2.08l.42.24v.28c.12-.17.34-.15.54 0a1.37 1.37 0 01.65 1.2v1.32l-.43-.25v-1.26a.75.75 0 00-.37-.68c-.25-.14-.38 0-.38.28zm2.14.04l.47.19c.1 0 .13 0 .13-.07a.63.63 0 00-.34-.52c-.23-.13-.36 0-.37.16l-.4-.33c0-.34.32-.5.76-.24a1.41 1.41 0 01.77 1.22v1.35l-.4-.23a2.07 2.07 0 010-.28c-.08.11-.26.18-.55 0a1.23 1.23 0 01-.61-1c0-.31.23-.38.54-.25zm.6.68v-.1l-.47-.19c-.14 0-.24 0-.24.15a.52.52 0 00.26.42c.24.14.45.12.45-.28zm2 .43a.71.71 0 00-.14-.1c-.33-.19-.48-.06-.48.33v1l-.44-.25v-2.09l.42.24v.34c.09-.18.29-.2.53-.06l.11.08zm.58-1.23a.64.64 0 01.28.49c0 .18-.13.25-.28.16a.6.6 0 01-.28-.48c.05-.18.12-.25.28-.17zm-.22 3V84.4l.43.25v2.09zm2.72.54c0 .65-.39.88-.94.57a2 2 0 01-.93-1.65c0-.64.4-.88.93-.57a2 2 0 01.94 1.65zm-.43-.25a1.12 1.12 0 00-.51-1c-.26-.15-.5-.06-.5.37a1.13 1.13 0 00.5.95c.27.22.51.13.51-.31zm1.07.99a.72.72 0 00.37.57c.17.1.27 0 .27-.09a.48.48 0 00-.22-.35l-.26-.22a1.25 1.25 0 01-.49-.89c0-.37.29-.51.67-.29a1.4 1.4 0 01.69 1l-.36-.09a.69.69 0 00-.33-.5c-.16-.09-.26 0-.26.09a.44.44 0 00.18.32l.27.22a1.3 1.3 0 01.52.94c0 .32-.22.54-.68.27a1.5 1.5 0 01-.75-1.06z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Icons_navigation_clipboard",
  "data-name": "Icons/navigation/clipboard"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Combined-Shape"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__path-184-2",
  "data-name": "path-184",
  d: "M300.79 70.25a.41.41 0 00-.08.22v.08l-.6-.35v5.37l4.29 2.48v-5.37l-.6-.34a.77.77 0 00-.07-.32v-.06l.69.4a.7.7 0 01.33.54v5.37c0 .2-.15.27-.33.17l-4.29-2.48a.69.69 0 01-.33-.55V70c0-.19.14-.27.33-.16zm2.7 5.49a.35.35 0 01.15.26c0 .1-.07.15-.15.1L301 74.66a.35.35 0 01-.15-.26c0-.1.07-.15.15-.1zm0-1.07a.32.32 0 01.15.26c0 .1-.07.14-.15.1L301 73.59a.36.36 0 01-.15-.27c0-.1.07-.14.15-.09zm0-1.08a.36.36 0 01.15.27c0 .1-.07.14-.15.09L301 72.51a.32.32 0 01-.15-.26c0-.1.07-.14.15-.1zM302.24 70a1.73 1.73 0 01.78 1.16 5.25 5.25 0 01.62 1c0 .2-.14.28-.31.18l-2.17-1.25a.69.69 0 01-.31-.54c0-.08.21-.19.62-.33.07-.31.39-.43.77-.22zm0 .54c-.17-.1-.31 0-.31.18a.66.66 0 00.31.53c.18.1.31 0 .31-.17a.67.67 0 00-.31-.53z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#run_svg__mask-5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Steel_ULTRALIGHT-5",
  "data-name": "Color/Steel_ULTRALIGHT"
}, /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Color_Green-Light-5",
  "data-name": "Color/Green-Light"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Swatch-5",
  "data-name": "Swatch",
  className: "run_svg__cls-72",
  d: "M298.53 67.15l7.43 4.29v8.59l-7.43-4.29v-8.59z"
}))))), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path",
  d: "M303.88 54.23a.4.4 0 00-.5.21s0 .2-1.1-.4c-1.07-.63-1.1-.87-1.1-.87a1.78 1.78 0 00-.5-.78c-1.84-1.41-2.12-2.27-2.17-2.81a2.44 2.44 0 01.13-.94 3.92 3.92 0 00.21-2.19 5.33 5.33 0 00-1.38-2c-.16-.16-.74-.76-1.08-1.14a5.56 5.56 0 01-.9-1.28 5.74 5.74 0 01-.41-1 17.5 17.5 0 003.57 3.43 2.58 2.58 0 01.5.92c.53-.62 1.48-.67 3 .22l.28.15a6.91 6.91 0 013 3.28.55.55 0 01.51-.34c.52 0 1.75 1 3.56.69a1.33 1.33 0 01-.74.68 3.07 3.07 0 01-1.28 0c-.79-.11-1.62-.21-1.77.34a7.19 7.19 0 00.22 2.41 5.58 5.58 0 01.13 1.05c-.06.5-.24 1.14-2.18.37z",
  fill: "#08c47f"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Shape",
  className: "run_svg__cls-80",
  d: "M309.7 49.5a.44.44 0 00-.2-.34.23.23 0 00-.11 0 4.58 4.58 0 01-2.79-.45 2.41 2.41 0 00-.75-.24.66.66 0 00-.43.17 7.38 7.38 0 00-3-3.07l-.28-.16c-1.35-.79-2.36-.92-3-.4a3.26 3.26 0 00-.43-.66 3.82 3.82 0 00-.75-.63 12.14 12.14 0 01-2.79-2.78c-.07-.1-.17-.15-.24-.12s-.09.12 0 .23.16.56.19.69a15.13 15.13 0 01.85 3.06c0 .12 0 .26.05.4l.58.44-.46.13a5.46 5.46 0 00.69 1.6h.68l-.26.55a3.7 3.7 0 001.17.83 2.61 2.61 0 00-.06.76 2.69 2.69 0 00.49 1.26 8.11 8.11 0 001.84 1.83 1.37 1.37 0 01.35.55c.07.29.48.65 1.28 1.13a3.45 3.45 0 001 .45c.17 0 .24 0 .27-.09a.27.27 0 01.35-.15 2.81 2.81 0 001.9.28.78.78 0 00.43-.78 6.16 6.16 0 00-.06-.72 3 3 0 00.46.3l-.08-.73.41.84v-.37l.26.47a1 1 0 00.84-.33l-.68-1 .88.74a2.26 2.26 0 00.26-.77l-.4-.45.45.18-.58-.65.61.36a5.88 5.88 0 01.81-1.75c0-.08.16-.38.2-.45a.2.2 0 00.05-.16zm-5.82 4.73a.4.4 0 00-.5.21s0 .2-1.1-.4c-1.07-.63-1.1-.87-1.1-.87a1.73 1.73 0 00-.5-.78c-1.84-1.41-2.12-2.27-2.17-2.81a2.44 2.44 0 01.13-.94 3.92 3.92 0 00.21-2.19 5.33 5.33 0 00-1.38-2c-.16-.16-.74-.76-1.08-1.14a5.56 5.56 0 01-.9-1.28 5.74 5.74 0 01-.41-1 17.5 17.5 0 003.57 3.43 2.58 2.58 0 01.5.92c.53-.62 1.48-.67 3 .22l.28.15a6.91 6.91 0 013 3.28.55.55 0 01.51-.34c.52 0 1.75 1 3.56.69a1.33 1.33 0 01-.74.68 3.07 3.07 0 01-1.28 0c-.79-.11-1.62-.21-1.77.34a7.19 7.19 0 00.22 2.41 5.58 5.58 0 01.13 1.05c0 .51-.23 1.14-2.17.38z"
}), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Spots"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-2",
  "data-name": "Path",
  className: "run_svg__cls-80",
  d: "M302.62 46.4c.11 0 .6.33.6.33s.2.23.14.26a.65.65 0 01-.52-.19c-.25-.19-.33-.38-.22-.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-3",
  "data-name": "Path",
  className: "run_svg__cls-80",
  d: "M302.58 46.91c.28.17.13.4 0 .34s-.42-.3-.39-.4.25-.04.39.06z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-4",
  "data-name": "Path",
  className: "run_svg__cls-80",
  d: "M301.71 45.81a1.28 1.28 0 01.47.6c0 .15-.12.12-.47 0a1.23 1.23 0 01-.66-.62c0-.14.46-.07.66.02z"
})), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Creases"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-5",
  "data-name": "Path",
  className: "run_svg__cls-80",
  d: "M300.7 49.75c.07 0 .64.2.77-.18 0 0 .2.82-.77.18z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-6",
  "data-name": "Path",
  className: "run_svg__cls-80",
  d: "M303.06 50.49a2.51 2.51 0 00.78 1.07c-1.03-.56-.78-1.07-.78-1.07z"
})), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Brow"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-7",
  "data-name": "Path",
  className: "run_svg__cls-80",
  d: "M299.41 46.94a16.67 16.67 0 011.81 2c.3.31.62.6.67.64a2.64 2.64 0 01-.49-.21c-.18.25-.52.26-.88 0a1.89 1.89 0 01-.92-1.37 1.5 1.5 0 010-.36 3.36 3.36 0 01.8.56 4.78 4.78 0 00-.87-.85 1.21 1.21 0 00-.44-.17s.06-.39.32-.24z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-8",
  "data-name": "Path",
  className: "run_svg__cls-80",
  d: "M305.08 50.56a1.79 1.79 0 00-.86-.15 3 3 0 01.79.35 1.34 1.34 0 010 .35c-.07.38-.35.63-.93.3a2.09 2.09 0 01-.88-1.06c-.19-.13-.53-.36-.48-.34s.37.09.67.13c.83.1 1.37-.14 1.8.13a1 1 0 01.34.62 1.87 1.87 0 00-.44-.33z"
})), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Eyes"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-9",
  "data-name": "Path",
  className: "run_svg__cls-81",
  d: "M304.22 50.41a3 3 0 01.79.36 1.25 1.25 0 010 .34c-.07.39-.34.64-.92.3a2.06 2.06 0 01-.88-1 4.06 4.06 0 001.01 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-10",
  "data-name": "Path",
  className: "run_svg__cls-81",
  d: "M301.4 49.32c-.18.26-.52.27-.87 0a2 2 0 01-.93-1.32 1.47 1.47 0 010-.36 3.59 3.59 0 01.79.55 13.68 13.68 0 001.01 1.13z"
})), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Pupil_Shine",
  "data-name": "Pupil Shine"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Pupil",
  className: "run_svg__cls-82",
  d: "M300.19 48.32s.9.77.87.94-.32.16-.59-.06a2.09 2.09 0 01-.49-.81c-.05-.13-.07-.35.21-.07z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Pupil-2",
  className: "run_svg__cls-82",
  d: "M304.43 50.77s-.89-.26-.86-.06a1 1 0 00.59.61c.27.09.43-.16.49-.23s.07-.27-.22-.32z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Shine",
  className: "run_svg__cls-32",
  d: "M300.72 48.83s.29.25.3.4-.43-.42-.54-.53 0-.11.24.13z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Shine-2",
  className: "run_svg__cls-32",
  d: "M303.9 50.66s-.29-.08-.3.06.43.08.54.09 0-.1-.24-.15z"
})), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Grin",
  d: "M305.2 52.39c0 .38-.26.46-.9.09l-.25-.15c-.7-.45-1-.74-1.75-1.17s-1.05-.5-1.74-.85l-.25-.13c-.64-.37-.88-.73-.91-1.14-.52.19.15 1.28.67 1.88a8.72 8.72 0 002.13 1.71l.21.12a4.87 4.87 0 002.13.75c.51 0 1.19-.31.66-1.11z",
  fill: "#222"
}), /*#__PURE__*/React.createElement("g", {
  id: "run_svg__Teeth"
}, /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-11",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M299.7 50.26a1.75 1.75 0 01-.36-.9 1.72 1.72 0 00.53.68l-.19.19z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-12",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M300.09 50.78l-.26-.33.2-.21.07.54s.01.03-.01 0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-13",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M300.25 50.88l-.07-.57h.09a1.59 1.59 0 00.26.14v.11l-.35.33z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-14",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M301.05 51.7a7.88 7.88 0 01-.62-.55.16.16 0 010-.07l.41-.39.28 1v.07h-.06z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-15",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M301.27 51.8l-.3-1v-.06c0-.06 0 0 0 0l.24.11.45.2v.05l-.46.73z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-16",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M302.09 52.42c-.21-.13-.41-.26-.59-.39a.15.15 0 01-.05-.06.08.08 0 010-.07l.4-.64.27 1.08v.06z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-17",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M302.32 52.47l-.32-1.26v-.06c0-.01 0 0 0 0l.28.15.28.17a.12.12 0 01.05.05.2.2 0 010 .07z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-18",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M303.1 53l-.59-.3-.06-.06a.09.09 0 010-.07l.27-.76.4 1.09a.08.08 0 010 .07z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-19",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M303.3 53l-.47-1.26a.07.07 0 010-.05l.45.31a2.48 2.48 0 00.26.19.1.1 0 010 .05l-.3.73z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-20",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M304.17 53.31a3.58 3.58 0 01-.62-.17.09.09 0 01-.06-.06.08.08 0 010-.08l.28-.66c.06.14.3.65.41.87a.15.15 0 010 .06z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-21",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M304.42 52.76l-.07.49-.35-.73a.06.06 0 010-.06l.26.16.08.05a.07.07 0 01.08.09z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-22",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M304.77 53.3h-.26v-.05l.07-.47.2.44z"
}), /*#__PURE__*/React.createElement("path", {
  id: "run_svg__Path-23",
  "data-name": "Path",
  className: "run_svg__cls-32",
  d: "M305 53.22h-.1l-.18-.41a.63.63 0 00.34 0 .31.31 0 00.19-.11v.1a.45.45 0 01-.25.42z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-25)",
  d: "M593.49 241.35v27.85l14.04-11.29 1.03-11.79-15.07-4.77z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M608.11 246.23c-13.37-3.75-12 14.61-12 14.61s-4.89-8.15-8.95-9.09-8 5.7-8 5.7l3.78-.32-2.45 4.59 4-1.09.35 5.3 4.07-4.35c-.46.5.81 4.1 1.08 4.7A20 20 0 00594 272c2.8 2.82 4.67 1.46 6.93-1.13a49.06 49.06 0 004.89-6.74c2.43-4 5.72-9.52 5.08-14.4a3.9 3.9 0 00-2.79-3.5z",
  fill: "url(#run_svg__linear-gradient-26)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M633.35 229.06a.82.82 0 00-.44 0 23.54 23.54 0 01-11.75.23 9.94 9.94 0 00-3-.32 5 5 0 00-2.08.81c-1.39-3.74-4.65-6.51-9.72-8.24l-1-.36c-5.07-1.73-9.34-1.54-12.73.56a5.08 5.08 0 00-1.14-1.92 9.66 9.66 0 00-2.58-1.6 23.52 23.52 0 01-9.14-7.39.86.86 0 00-.38-.27.84.84 0 00-.54 0 .78.78 0 00-.5.81c0 .31.08 1.72.09 2.11.07 1.71 1.14 5.61.28 9.53-.08.38-.16.82-.22 1.28l2.07 1.07-2.17.71a9.59 9.59 0 001.19 4.84l3-.42-1.73 2a8.86 8.86 0 004.2 2 8.13 8.13 0 00-1.13 2.52 4.94 4.94 0 00.71 3.86c1 1.63 3 3.22 6 4.85a2.19 2.19 0 01.92 1.59c0 .92 1.38 1.86 4.36 2.93h.13a13.4 13.4 0 004 .84 1.53 1.53 0 001.29-.48 2.19 2.19 0 011.71-.69c3.56.59 6.18.52 8-.24a4.77 4.77 0 002.79-2.83.19.19 0 000-.07 17.79 17.79 0 00.51-2.3 11.49 11.49 0 001.71.68l.46-2.35.86 2.51.61-1.25.62 1.38a7.4 7.4 0 004-1.58l-1.79-3 3 1.89a10.86 10.86 0 002-2.68l-1.22-1.23s1.73.33 1.74.32l-1.78-1.77 2.25.8c1.81-3 4.53-5.09 5.51-6.25.25-.28 1.15-1.34 1.37-1.58a.77.77 0 00.19-.3.8.8 0 00-.53-1z",
  fill: "#221f34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M633.35 229.06a.82.82 0 00-.44 0 23.54 23.54 0 01-11.75.23 9.94 9.94 0 00-3-.32 5 5 0 00-2.08.81c-1.39-3.74-4.65-6.51-9.72-8.24l-1-.36c-5.07-1.73-9.34-1.54-12.73.56a5.08 5.08 0 00-1.14-1.92 9.66 9.66 0 00-2.58-1.6 23.52 23.52 0 01-9.14-7.39.86.86 0 00-.38-.27.84.84 0 00-.54 0 .78.78 0 00-.5.81c0 .31.08 1.72.09 2.11.07 1.71 1.14 5.61.28 9.53-.08.38-.16.82-.22 1.28l2.07 1.07-2.17.71a9.59 9.59 0 001.19 4.84l3-.42-1.73 2a8.86 8.86 0 004.2 2 8.13 8.13 0 00-1.13 2.52 4.94 4.94 0 00.71 3.86c1 1.63 3 3.22 6 4.85a2.19 2.19 0 01.92 1.59c0 .92 1.38 1.86 4.36 2.93h.13a13.4 13.4 0 004 .84 1.53 1.53 0 001.29-.48 2.19 2.19 0 011.71-.69c3.56.59 6.18.52 8-.24a4.77 4.77 0 002.79-2.83.19.19 0 000-.07 17.79 17.79 0 00.51-2.3 11.49 11.49 0 001.71.68l.46-2.35.86 2.51.61-1.25.62 1.38a7.4 7.4 0 004-1.58l-1.79-3 3 1.89a10.86 10.86 0 002-2.68l-1.22-1.23s1.73.33 1.74.32l-1.78-1.77 2.25.8c1.81-3 4.53-5.09 5.51-6.25.25-.28 1.15-1.34 1.37-1.58a.77.77 0 00.19-.3.8.8 0 00-.53-1z",
  fill: "url(#run_svg__linear-gradient-27)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M623.46 233.23c-3.35.22-6.1.64-7.35 2.52s-1.5 5-1.75 7.76c0 .31-.06.61-.1.92a12.91 12.91 0 001.7.74l.46-2.35.86 2.51.61-1.25.62 1.38a7.4 7.4 0 004-1.58l-1.79-3 3 1.89a10.86 10.86 0 002-2.68l-1.22-1.23s1.73.33 1.74.32l-1.78-1.77 2.25.8c1.81-3 4.53-5.09 5.51-6.25.25-.28 1.15-1.34 1.37-1.58-3.35 2.47-6.75 2.62-10.13 2.85z",
  fill: "url(#run_svg__linear-gradient-28)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M606.3 224.22c.5-.14 2.27.72 2.27.72.42.22.6.64.29.78a2.66 2.66 0 01-2.06-.3c-.85-.49-1-1.06-.5-1.2z",
  fill: "url(#run_svg__linear-gradient-29)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M605.56 225.92c1 .41.1 1.26-.57 1.17s-1.52-.75-1.25-1.09 1.29-.3 1.82-.08z",
  fill: "url(#run_svg__linear-gradient-30)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M603 222.87a2.15 2.15 0 011.38 1.67c-.06.46-.66.46-2 .2s-2.34-1.29-2.22-1.65 2.07-.41 2.86-.22z",
  fill: "url(#run_svg__linear-gradient-31)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M588.83 226.42c-.1-1.24-.07-3-3.05-5.42a20.32 20.32 0 01-3.48-3.08 22.74 22.74 0 01-4-6.5c0 .31.08 1.72.09 2.11.07 1.71 1.14 5.61.28 9.53-.08.38-.16.82-.22 1.28l2.07 1.07-2.17.71a9.59 9.59 0 001.19 4.84l3-.42-1.73 2a8 8 0 004.21 2l.5-.74c1.42-2.21 3.48-5.11 3.31-7.38z",
  fill: "url(#run_svg__linear-gradient-32)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M609.29 242.14c-.51 1.14-1.54 1.52-3.72.76a8.93 8.93 0 01-.83-.33c-2.3-1-3.21-1.66-5.76-2.56s-3.7-.91-6.1-1.59c-.31-.08-.59-.18-.85-.27-2.18-.76-2.75-1.7-2.44-2.91-2.29.84-.74 3.74.71 5.24a18.17 18.17 0 006.73 4l.7.24a18.28 18.28 0 007.74 1.11c2-.25 5.09-1.55 3.82-3.65z",
  fill: "url(#run_svg__linear-gradient-33)"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M589.51 238.71c-.38-.64-.92-1.74-.5-2.48h.1a2.78 2.78 0 001.41 1.72.05.05 0 010 .09l-.94.66a.05.05 0 01-.08 0zm1.01 1.35a8.12 8.12 0 01-.69-.86.07.07 0 010-.11l1-.72h.09l-.29 1.6c0 .09-.08.11-.14 0zm.54.22l.31-1.68a.17.17 0 01.23-.13l.29.1a6.55 6.55 0 00.88.28h.07a.17.17 0 010 .3l-1.74 1.17a.06.06 0 01-.09-.06zm2.36 2a13.25 13.25 0 01-1.91-1.3.23.23 0 010-.36c.52-.35 1.72-1.15 2-1.38a.06.06 0 01.09 0l.1 2.79a.22.22 0 01-.33.2zm.77.19l-.09-3a.23.23 0 01.28-.22l.87.19c.52.12 1 .23 1.57.37a.16.16 0 01.07.28l-2.6 2.41a.06.06 0 01-.1 0zm2.63 1.41c-.71-.27-1.36-.56-2-.84a.23.23 0 01-.06-.37l2.25-2.1a.06.06 0 01.1 0v3.07a.22.22 0 01-.3.2zm.85.03a.06.06 0 01-.1 0v-3.54a.22.22 0 01.29-.21l1 .31.94.35a.23.23 0 01.09.35l-2.19 2.78zm2.62 1.03c-.65-.15-1.34-.34-2.06-.56a.22.22 0 01-.11-.35l1.9-2.41a.05.05 0 01.1 0l.44 3.05a.22.22 0 01-.27.25zm.77-.05l-.53-3.51a.17.17 0 01.24-.18c.51.23 1 .46 1.45.7l.87.42a.17.17 0 01.06.26l-2 2.34a.06.06 0 01-.1 0zm3.13.54a13.74 13.74 0 01-2.31-.18.22.22 0 01-.13-.36l1.82-2.13a.06.06 0 01.1 0c.12.38.55 1.76.73 2.36a.22.22 0 01-.21.29zm1.6-1.78l-.82 1.51a.06.06 0 01-.1 0l-.62-2a.16.16 0 01.22-.2h.07c.31.14.6.24.86.33l.29.1a.17.17 0 01.1.24zm.82 1.44a9.73 9.73 0 01-1.07.24c-.09 0-.13-.05-.09-.13l.77-1.42a.05.05 0 01.1 0l.35 1.19a.09.09 0 01-.06.11zm.99-.36l-.41.17a.06.06 0 01-.08 0l-.32-1.11a.06.06 0 01.06-.07 3.35 3.35 0 001.31 0 2.15 2.15 0 00.88-.44.06.06 0 01.09.06 1.43 1.43 0 01-.09.27 2.91 2.91 0 01-1.44 1.17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.32 227.74c1.74.55 3.21 3.25 6 5.69 1 .89 2.18 1.72 2.35 1.84a15.47 15.47 0 01-2-.45 4.06 4.06 0 01-4.16.68 3.64 3.64 0 01-2.64-4.19 4.19 4.19 0 01.37-1.25 10.51 10.51 0 013 1.45 9.66 9.66 0 00-3-2.4 5.17 5.17 0 00-1.82-.36s.82-1.35 1.87-1zm21.18 8.83a9.69 9.69 0 00-3.86 0 10.71 10.71 0 013.28.76 4.75 4.75 0 01-.5 1.21 3.66 3.66 0 01-4.69 1.62 4.09 4.09 0 01-2.82-3.13 14.86 14.86 0 01-1.85-.92c.21 0 1.62.09 3 0 3.74-.14 6.56-1.32 8.26-.66 1 .39.81 1.95.81 1.95a5.18 5.18 0 00-1.62-.87z",
  fill: "#313866"
}), /*#__PURE__*/React.createElement("path", {
  d: "M608.63 236.58a10.55 10.55 0 013.27.75 4.82 4.82 0 01-.5 1.22 3.66 3.66 0 01-4.68 1.62 4.06 4.06 0 01-2.81-3.13 25 25 0 004.72-.46zm-10.94-1.75a4.05 4.05 0 01-4.15.69 3.63 3.63 0 01-2.63-4.19 4.65 4.65 0 01.36-1.26 10.65 10.65 0 013 1.46 23.59 23.59 0 003.39 3.3z",
  fill: "#3eb883"
}), /*#__PURE__*/React.createElement("path", {
  d: "M596.15 234.83c.34-.61-2.89-2.73-2.89-2.73-1-.81-1.16-.06-1.08.37s.28 2 1.31 2.5 2.43.27 2.66-.14zm13.66 3.85a3.55 3.55 0 01-2.58 1.13c-1.16-.14-2.09-1.08-2-1.77s4-.33 4-.33c.51.03 1.38.2.58.97z",
  fill: "#7dc9a9"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-32",
  d: "M595.11 233.53s1 .69.9 1.22-1.48-1.19-1.85-1.53.1-.37 1 .31zm11.73 4.14s-1.25-.12-1.46.39 1.9 0 2.39 0 .16-.36-.93-.36z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M497 367.62l18.64 10.67a1.53 1.53 0 010 2.64L500 390a3 3 0 01-3 0l-18.63-10.67a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 012.93-.02zm29 16.7L544.59 395a1.52 1.52 0 010 2.63l-15.69 9.07a3 3 0 01-3 0L507.24 396a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 013.06.01zm-57.89-33.39l18.63 10.67a1.52 1.52 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-18.65-10.67a1.52 1.52 0 010-2.63l15.69-9.06a3 3 0 013.02 0zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.63l-15.7 9.06a3 3 0 01-3 0l-18.64-10.67a1.53 1.53 0 010-2.64l15.69-9.06a3 3 0 013.02.01zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.63l-15.7 9.06a3 3 0 01-3 0l-18.64-10.67a1.52 1.52 0 010-2.63l15.69-9.06a3 3 0 013.02 0zm-28.92-16.7L400 311.5a1.51 1.51 0 010 2.63l-15.69 9.07a3 3 0 01-3 0l-18.63-10.67a1.51 1.51 0 010-2.63l15.69-9.06a3 3 0 012.98-.01zm-28.93-16.7l18.64 10.67a1.53 1.53 0 010 2.64l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 012.98-.01zm-28.92-16.69l18.64 10.67a1.52 1.52 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 012.98 0zm-42.07-24.29l31.79 18.26a1.52 1.52 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-31.79-18.25a1.52 1.52 0 010-2.63l15.69-9.07a3 3 0 013 0zM486.7 391.81l31.78 18.26a1.52 1.52 0 010 2.63l-15.7 9.06a3 3 0 01-3 0L468 403.51a1.52 1.52 0 010-2.64l15.69-9.06a3 3 0 013.01 0zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.63l-15.7 9.06a3 3 0 01-3 0l-18.64-10.67a1.53 1.53 0 010-2.64l15.69-9.06a3 3 0 013.02.01zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 012.99 0zm-28.93-16.7l18.64 10.67a1.53 1.53 0 010 2.64l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 012.98-.01zM371 325l18.64 10.68a1.52 1.52 0 010 2.63L374 347.38a3 3 0 01-3 0l-18.7-10.67a1.52 1.52 0 010-2.63L368 325a3.06 3.06 0 013 0zm-28.91-16.68L360.72 319a1.52 1.52 0 010 2.63L345 330.68a3 3 0 01-3 0L323.37 320a1.52 1.52 0 010-2.63l15.69-9.06a3 3 0 013.03.01zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.63L316.11 314a3 3 0 01-3 0l-18.64-10.67a1.53 1.53 0 010-2.64l15.69-9.06a3 3 0 013.01-.01zm-28.92-16.7l18.63 10.67a1.51 1.51 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.51 1.51 0 010-2.63l15.69-9.06a3 3 0 013 0zm-28.93-16.7L274 268.89a1.53 1.53 0 010 2.64l-15.69 9.06a3 3 0 01-3 0l-16.34-9.36a3 3 0 010-5.26l13.41-7.74a3 3 0 012.94-.01zM452.48 402.2l39.9 22.94a1.52 1.52 0 010 2.63l-15.7 9.06a3.06 3.06 0 01-3 0l-39.9-22.95a1.52 1.52 0 010-2.63l15.69-9.06a3.05 3.05 0 013.01.01zm-28.7-16.57l18.63 10.67a1.52 1.52 0 010 2.63L426.72 408a3 3 0 01-3 0l-18.64-10.67a1.53 1.53 0 010-2.64l15.69-9.06a3 3 0 013.01 0zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.63l-15.7 9.06a3 3 0 01-3 0l-18.64-10.67a1.52 1.52 0 010-2.63l15.69-9.06a3 3 0 013.02 0zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.64l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.51 1.51 0 010-2.63l15.69-9.06a3.06 3.06 0 013-.01zM337 335.53l18.64 10.68a1.52 1.52 0 010 2.63L340 357.9a3 3 0 01-3 0l-18.7-10.67a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 013-.01zm-28.91-16.69l18.64 10.67a1.52 1.52 0 010 2.63L311 341.2a3.06 3.06 0 01-3 0l-18.63-10.68a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 013.02.01zm-28.92-16.7l18.63 10.67a1.52 1.52 0 010 2.63l-15.69 9.06a3.06 3.06 0 01-3 0l-18.64-10.67a1.53 1.53 0 010-2.64l15.69-9.06a3 3 0 013.01.01zm-49.95-28.84l39.67 22.81a1.52 1.52 0 010 2.63l-15.69 9.06a3.06 3.06 0 01-3 0L210.49 285a1.52 1.52 0 010-2.63l15.69-9.07a3.05 3.05 0 013.04 0zm218.41 156.25l18.63 10.67a1.51 1.51 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.51 1.51 0 010-2.63l15.69-9.06a3 3 0 013 0zm-28.93-16.7l18.64 10.67a1.52 1.52 0 010 2.63l-15.69 9.06a3.06 3.06 0 01-3 0L400 424.54a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 013 0zm-28.92-16.7l18.64 10.67a1.52 1.52 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.53 1.53 0 010-2.64l15.7-9.06a3 3 0 012.98.01zM261 321.77l18.63 10.67a1.52 1.52 0 010 2.63l-15.7 9.06a3 3 0 01-3 0l-18.64-10.68a1.52 1.52 0 010-2.63l15.69-9.06a3 3 0 013.02.01zm-29-16.7l18.63 10.67a1.52 1.52 0 010 2.63L235 327.43a3.06 3.06 0 01-3 0l-18.63-10.67a1.53 1.53 0 010-2.64l15.63-9.05a3 3 0 013 0zm-28.9-16.7L221.74 299a1.52 1.52 0 010 2.63l-15.69 9.06a3 3 0 01-3 0l-18.63-10.67a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 012.98.04zm86.77 50.1l89.63 51.65a1.52 1.52 0 010 2.63l-15.7 9.06a3 3 0 01-3 0l-89.64-51.65a1.52 1.52 0 010-2.63l15.7-9.06a3 3 0 013.01 0zm62.45 72.59L258.54 357a12.13 12.13 0 00-12.14 0l-49.63 28.66a4.51 4.51 0 00-2.21 3.18 4.52 4.52 0 012.21-4.7l49.63-28.66a12.13 12.13 0 0112.14 0l93.78 54.09a4.54 4.54 0 012.21 4.71 4.48 4.48 0 00-2.21-3.22z",
  fill: "#cfd6ec"
}), /*#__PURE__*/React.createElement("path", {
  d: "M317.55 335.25L361 360.49l24.36-14.11-43.46-25.17z",
  fill: "url(#run_svg__linear-gradient-34)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M344.14 345l48.37 27.95 27-15.67L384.57 337z",
  fill: "url(#run_svg__linear-gradient-35)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-36)",
  d: "M381.4 335.59l-38.5 8.46 35.04 20.43 26.5-15.59-23.04-13.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#run_svg__linear-gradient-37)",
  d: "M356.73 326.86l-38.51 8.47 35.04 20.43 26.5-15.6-23.03-13.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-102",
  d: "M312.39 186.56s-7.32 15.33-6.85 22.52 21.57 9.77 21.57 9.77l2.58-30.06-17.3-2.23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-103",
  d: "M322.43 166.68s-6.64.34-14.65 22.73c0 0 4.61 6.91 16.15 7.25.06 0 10.65-29.78-1.5-30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M322.43 166.68s-6.64.34-14.65 22.73c0 0 4.61 6.91 16.15 7.25.06 0 10.65-29.78-1.5-30z",
  fill: "url(#run_svg__linear-gradient-38)"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-102",
  d: "M315.38 283.83l1.15 43.55 13.91-6.3.68-45.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-105",
  d: "M353.43 318.36c.62-.68 2.72-2.51 2-3.39-2.85-3.32-19 1-23.27 1.7-1 .13-1.08-1.36-1.49-1.43-.2-.07-4.07 1.9-5.83 2.38-5.43 1.49-9 .06-9 .06a52.52 52.52 0 00-.4 12.28c.2 2.72 1.22 6 4.34 6 8 .07 27-10.51 33.64-17.64z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-102",
  d: "M340.68 278l2.32 57.19 12.95-6.11 1.36-56.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-105",
  d: "M357.17 327.38a14.87 14.87 0 00.88 1.84c.61.81 19.94 3 26.52 7.8 1.77 1.29.07 2.44-1.35 3.12-8.76 4-30.67 5.7-37.65 5.29a3.66 3.66 0 01-3.46-3.66c0-4.07-.48-11.26.4-12.35.27-.34.88 0 1.36.07a22.61 22.61 0 005.63.2 10.14 10.14 0 005.22-2 3.3 3.3 0 011.16-.74c.74-.27 1.08 0 1.29.4z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-102",
  d: "M330.64 155.49v17.23c0 2.71 2.65 4.81 5.63 4.47a4.49 4.49 0 004.28-4.27v-15.4"
}), /*#__PURE__*/React.createElement("circle", {
  className: "run_svg__cls-102",
  cx: 337.15,
  cy: 149.99,
  r: 13.91
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-105",
  d: "M334.71 155.62c-1.69 1.9-4.27 2-6.51 1.83-4.55-.4-7.39-5.42-6.78-14.24.2-3.39.95-8.82 8.2-11.26 5-1.7 21 .2 21.85.07.07 0 1 8.34-1.63 11.87-.34.47-9 1.42-10 1.35-.68-.06-1.43-.34-2 .21a4.49 4.49 0 00-1.29 2.85c-.13.88-.34 1.76-.47 2.64a11.45 11.45 0 01-1 4.07 1.27 1.27 0 01-.37.61zm21.1 58.38l-21.23-.34.06-4.54h-20.55l-3.66 17 2.3 63.15s12 6 21-3.39l.14-36.7h.47a.7.7 0 01.75.68l2.37 42.74s13 7.53 22.12-2l-.41-68.11-3.36-8.49z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-103",
  d: "M352.28 172.51a6.41 6.41 0 00-1.42-1.22c-3.19-1.9-27.61-10.31-31.07-2.51-3.19 7.13-11.53 56.37-10.58 57.19 4.27 3.66 19.13 13.09 51.69 3.66 1.08-.27-6.79-55-8.62-57.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M353.77 178.14l-.61.21c-1.56 2.71-13.5-3.33-14-.27-1.22 7.59 14.38 21.57 16.69 53 1.63-.41 3.32-.82 5-1.36.93-.36-4.16-37.19-7.08-51.58z",
  fill: "url(#run_svg__linear-gradient-39)"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-102",
  d: "M381.79 203.79A6.24 6.24 0 01378 203l-32.9-18.79a6.19 6.19 0 01-2.31-8.34c1.7-2.92 5.84-4.75 8.76-3.06L377 187.37c2-10.45.68-6.44 2.65-17 1.36-7.19 4.41-24.15 7.05-24.22 2.38-.06-.06 10.18.14 10.38a15.52 15.52 0 002.58 1.7 8.14 8.14 0 012.58 5.47c1 7-4.07 29.91-5 35.07a5.91 5.91 0 01-3.46 4.41 3.52 3.52 0 01-1.76.61z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-102",
  d: "M378.13 162.61a14.57 14.57 0 01-.34-5.43 2.22 2.22 0 011.22-1.83 1.69 1.69 0 011.76.68 4.77 4.77 0 01.75 1.83 49.91 49.91 0 011.7 9c.06 1.22.61 7.32-.82 7.86-2.44.95-4.07-10.92-4.27-12.07z"
}), /*#__PURE__*/React.createElement("path", {
  className: "run_svg__cls-103",
  d: "M339.12 172.72c-1.69 4.41-.88 8.75 2.71 11.73a66 66 0 0016.76 10.45 48.68 48.68 0 005.63-16.15c.2-.33-21.16-16.14-25.1-6z"
})));

function SvgRun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 715.16 610.38"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/run.91fbad6e.svg";
export { SvgRun as ReactComponent };